import React from 'react'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  makeStyles
} from '@material-ui/core'
import { ArrowRight } from '@material-ui/icons'
import { Clear2Icon, DropDownIcon } from '@core'
import { isEmpty, map } from 'lodash'
import classNames from 'classnames'
import { CentricTypography as Typography } from '@core/component/CentricTypography'
import { useObserver } from 'mobx-react-lite'
import { CNFAttributeFilterValueRow } from './CNFAttributeFilterValueRow'
import { MoreFilterPopup } from '../moreFilterPopup/container/MoreFilterPopup'
import { useTranslation } from 'react-i18next'
import { isEmptyValue } from '@utils/object-utils'

const useStyles = makeStyles(theme => ({
  accordionContainer: {
    position: 'relative',
    margin: '0px 10px'
  },
  stickySummary: {
    position: 'sticky',
    top: 0,
    backgroundColor: theme.palette.background.paper,
    zIndex: 1,
    minHeight: '44px',
    '&.Mui-expanded': {
      minHeight: '44px',
      marginBottom: '-12px'
    },
    '& .Mui-expanded': {
      margin: '0px'
    }
  },
  accordionDetails: {
    padding: '6px 0 0 0'
  },
  icons: {
    display: 'flex',
    alignItems: 'center',
    marginRight: '6px'
  },
  iconsWrapper: {
    display: 'flex',
    alignItems: 'center',
    width: '80%',
    cursor: 'pointer'
  },
  listWrapper: {
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    padding: '0 0 0 15px',
    width: '100%'
  },
  listElement: {
    width: 'calc(100% - 10px)'
  },
  collapsibleName: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    cursor: 'initial'
  },
  accordion: {
    boxShadow: '0px 0px'
  },
  clearFilterWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    width: '20%',
    cursor: 'pointer'
  },
  clearIcon: {
    color: theme.palette.text.disabled
  },
  disabled: {
    pointerEvents: 'none'
  }
}))

const CNFProductFilterCollapse = ({
  filterId,
  collapsibleName,
  values,
  handleFilterSelection,
  selectedFilter,
  clearFilter,
  excludedFilters,
  handleFilterExclusion,
  handleFilterExpansion,
  expanded,
  filterStore,
  defaultEmptyText
}) => {
  return useObserver(function useHook() {
    const classes = useStyles()
    const { t } = useTranslation()

    const filterValues = values?.slice(0, 12)
    const moreFilterValues = values?.slice(12)
    const hasSelectedFilter = !isEmpty(selectedFilter?.[filterId])
    return (
      <div className={classes.accordionContainer}>
        <Accordion expanded={expanded} className={classes.accordion}>
          <AccordionSummary className={classes.stickySummary}>
            <div className={classes.collapsibleName}>
              <div
                className={classes.iconsWrapper}
                onClick={() => handleFilterExpansion(filterId)}
              >
                <div className={classes.icons}>
                  {expanded ? <DropDownIcon /> : <ArrowRight />}
                </div>
                <Typography variant='subtitle1'>
                  {`${collapsibleName} ${
                    selectedFilter?.[filterId]?.length
                      ? `(${selectedFilter?.[filterId]?.length})`
                      : ''
                  }`}
                </Typography>
              </div>
              <div
                className={classNames(
                  classes.clearFilterWrapper,
                  !hasSelectedFilter && classes.disabled
                )}
                onClick={() => clearFilter(filterId)}
              >
                <Clear2Icon className={!hasSelectedFilter ? classes.clearIcon : ''} />
                <Typography
                  variant={hasSelectedFilter ? 'captionDarkGrey' : 'captionLightGrey'}
                >
                  {t('common.label.clear', 'Clear')}
                </Typography>
              </div>
            </div>
          </AccordionSummary>
          <AccordionDetails className={classes.accordionDetails}>
            <div className={classes.listWrapper}>
              {map(filterValues, ({ value, count }) => (
                <CNFAttributeFilterValueRow
                  id={value}
                  key={value}
                  attributeId={filterId}
                  name={isEmptyValue(value) ? defaultEmptyText : value}
                  handleCheckboxSelection={(e, checked) => {
                    handleFilterSelection(checked, { value, count }, filterId)
                  }}
                  isSelected={
                    !!selectedFilter?.[filterId]?.some(ele => ele.value === value)
                  }
                  handleFilterExclusion={() => {
                    handleFilterExclusion({ value, count }, filterId)
                  }}
                  canShowCheckbox={true}
                  isExcluded={
                    !!excludedFilters?.[filterId]?.some(ele => ele.value === value)
                  }
                  isDisabled={false}
                  filterCount={count}
                />
              ))}
              {moreFilterValues.length ? (
                <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
                  <MoreFilterPopup
                    filterValues={values}
                    filterId={filterId}
                    filterLabel={collapsibleName}
                    moreCount={moreFilterValues.length}
                    filterStore={filterStore}
                    handleFilterSelection={handleFilterSelection}
                    handleFilterExclusion={handleFilterExclusion}
                    defaultEmptyText={defaultEmptyText}
                  />
                </div>
              ) : null}
            </div>
          </AccordionDetails>
        </Accordion>
      </div>
    )
  })
}

export default CNFProductFilterCollapse
